export const TYPE = 'line-body';

const LineBody = fabric.util.createClass(fabric.Line, {
  type: TYPE,

  initialize: function (options: fabric.ILineOptions) {
    const defaults: fabric.ILineOptions = {
      id: TYPE,
      originX: 'center',
      fill: 'black',
      stroke: 'black',
      strokeWidth: 2,
      top: 10,
    } as fabric.ILineOptions;
    const points = options ? [options.x1 ?? 0, options.y1 ?? 350, options.x2 ?? 0, options.y2 ?? 0] : [0, 350, 0, 0];

    this.callSuper('initialize', points, { ...defaults, ...options });
  },

  toObject: function () {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.id,
    });
  },
});

LineBody.fromObject = function (object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const lineBody = new LineBody(object);
  if (callback) callback(lineBody);
  return lineBody;
};

export default LineBody;
